export default __webpack_public_path__ + "static/media/roadmapBg2.b8bb135c.png";